<template>
  <div class="header">
    <div class="logo">
      <img src="../images/logo.png" alt="" />
      <!-- <p>上蔡县公共数据文化平台</p> -->
    </div>
    <div class="login">
      <el-input v-model="input" placeholder="请输入内容"></el-input>
      <span class="search" @click="search()">搜索</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "Header",
  data() {
    return {
      input: ""
    };
  },
  methods: {
    search() {
      if (this.input == "") {
        this.$message({
          message: "请填写搜索内容",
          type: "warning"
        });
      } else {
        this.$router.push({
          path: "/search",
          query: { title: this.input }
        });
      }
    }
  },
  created() {}
};
</script>
<style scoped>
.header {
  width: 1200px;
  height: auto;
  margin: 0 auto;
  background-color: #fff;
  display: flex;
  padding: 10px 0px;
}
.header .logo {
  height: 100%;
  display: inline-block;
  width: 50%;
  margin-top: 10px;
  /* font-size: 28px;
  line-height: 40px; */
}
.header .logo img {
  width: auto;
  height: auto;
  vertical-align: middle;
}
.header .login {
  width: 50%;
  height: 40px;
  display: flex;
  margin-top: 20px;
}
.header .el-input__inner {
  border: 1px solid #ccc;
}
.header .login .search {
  width: 100px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: red;
  font-size: 16px;
  color: #fff;
}
</style>